module.exports = __webpack_public_path__ + "static/media/44337402_2199893306752515_9218476766274781184_o-thumb.d70c36e3.jpg";